import { resetFacility } from 'app/redux/profile/facility/actions';
import { store } from 'app/redux/store';
import { getLoginRedirectUrl } from './getAuthenticationUrl';

export function redirectToLogin() {
  store.dispatch(resetFacility());
  window.location.href = getLoginRedirectUrl();
}
